import React from 'react';
import { ClubR } from '@rakutenfrance/shared-svg';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { CurrencyFormatter } from '../CurrencyFormatter';
import * as styles from './ClubRCagnotte.style';
export const ClubRCagnotte = ({ amount = 0, iconWidth = '50', iconHeight = '14', small = true, isLoading = false, isDisabled = false, }) => {
    return (React.createElement(Box, { sx: isDisabled ? styles.cagnotteDisabled() : styles.cagnotte(true), "data-qa": "club-r-cagnotte" },
        React.createElement(Box, { sx: styles.clubR },
            React.createElement(ClubR, { width: `${iconWidth}`, height: `${iconHeight}`, "data-qa": "club-r-icon" })),
        React.createElement(Divider, { sx: { height: '16px' }, orientation: "vertical", flexItem: true }),
        React.createElement(Typography, { sx: Object.assign(Object.assign({}, styles.amount), (small && { fontSize: 'smaller' })), variant: "subtitle2" }, isLoading ? (React.createElement(CircularProgress, { size: "2rem", style: { alignItems: 'center', marginTop: '5px' }, "data-qa": "loading-spinner" })) : (React.createElement(Box, { "data-qa": "club-r-amount" },
            React.createElement(CurrencyFormatter, { amount: amount }))))));
};
